import CssClassMixin from '../../mixins/css_class_mixin.jsx';
import InputComponentMixin from '../../mixins/input/input_component_mixin.jsx';

var createClass = require('create-react-class');

window.InputNumber = createClass({
  mixins: [CssClassMixin, InputComponentMixin],

  getDefaultProps: function() {
    return {
      themeClassKey: 'input.number',
      maskType: 'integer'
    };
  },

  componentDidMount: function() {
    Materialize.updateTextFields()
  },

  render: function() {
    return (
      <span>
        <InputMasked
          {...this.props}
          className={this.className()}
          onChange={this._handleChange}
          onFocus={this._handleFocus}
          type="text"
          ref="input"
        />
        <Label {...this.propsWithoutCSS()} />
      </span>
    );
  }
});
